import {
  Button,
  TextRephraseIcon,
  WandSparklesIcon,
} from '@buffer-mono/popcorn'

import styles from './AIAssistantTrigger.module.css'

import type { JSX } from 'react'

/**
 *
 */
interface AIAssistantTriggerProps {
  onClick: () => void
  hasSelection?: boolean
}

function AIAssistantTrigger({
  onClick,
  hasSelection = false,
}: AIAssistantTriggerProps): JSX.Element {
  return (
    <Button
      onClick={onClick}
      onMouseDown={(e) => {
        // Only prevent default for mouse events, not synthetic events from keyboard
        // This preserves keyboard accessibility while maintaining editor focus
        if (e.nativeEvent instanceof MouseEvent) {
          e.preventDefault()
        }
      }}
      id="button-ai-assistant-v2"
      data-testid="button-ai-assistant"
      variant="tertiary"
      className={styles.triggerButton}
    >
      {hasSelection ? (
        <>
          <TextRephraseIcon />
          Refine with AI
        </>
      ) : (
        <>
          <WandSparklesIcon />
          AI Assistant
        </>
      )}
    </Button>
  )
}

export { AIAssistantTrigger }
